import {
  Collapse,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  useBreakpointValue,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import {
  MODAL_FOOTER_PB,
  MOBILE_FULL_SCREEN_MODAL_CONTENT_PROPS,
  VIEWPORT_MIN_H,
} from '@/constants/mobileLayout';
import { AuthCards, type AuthCardsMode } from '..';

export function AuthModal(props: { mode: AuthCardsMode; isOpen: boolean; onClose: () => void }) {
  const [authUIReady, setAuthUIReady] = useState(false);
  const isMobile = useBreakpointValue({ base: true, md: false }) ?? true;

  useEffect(() => {
    if (props.isOpen) {
      setTimeout(() => setAuthUIReady(true), 250);
    } else {
      setAuthUIReady(false);
    }
  }, [props.isOpen]);

  return (
    <Modal
      closeOnOverlayClick
      isCentered={!isMobile}
      isOpen={props.isOpen}
      onClose={props.onClose}
      size={isMobile ? 'full' : 'md'}
      scrollBehavior='inside'
    >
      <ModalOverlay />
      <ModalContent
        {...(isMobile ? MOBILE_FULL_SCREEN_MODAL_CONTENT_PROPS : {})}
        minH={isMobile ? VIEWPORT_MIN_H : undefined}
      >
        <ModalCloseButton mt={2} mr={2} zIndex={2} />
        <ModalBody pt={{ base: 12, md: 8 }} pb={MODAL_FOOTER_PB} px={{ base: 5, md: 8 }}>
          <Collapse in={authUIReady} unmountOnExit={false}>
            <AuthCards initialMode={props.mode} />
          </Collapse>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
